var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllInclusive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0.262644 -5.5348e-09 0.522716 0.0517318 0.765368 0.152241C1.00802 0.252751 1.2285 0.400069 1.41422 0.585786C1.59993 0.771504 1.74725 0.991982 1.84776 1.23463C1.94827 1.47728 2 1.73736 2 2C2 2.26264 1.94827 2.52272 1.84776 2.76537C1.74725 3.00802 1.59993 3.2285 1.41422 3.41421C1.2285 3.59993 1.00802 3.74725 0.765368 3.84776C0.522716 3.94827 0.262644 4 0 4",
    transform: "translate(21.7344 10.3848)",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7745 0.285089C18.9272 0.135747 19.1237 0.0392172 19.3352 0.00963748C19.5467 -0.0199422 19.7622 0.0189818 19.95 0.120709C20.1378 0.222437 20.2881 0.381623 20.3789 0.574955C20.4697 0.768287 20.4962 0.985607 20.4545 1.19509V17.3251C20.4672 17.5194 20.4228 17.7132 20.327 17.8827C20.2311 18.0521 20.0878 18.1899 19.9147 18.2791C19.7416 18.3683 19.5462 18.4051 19.3526 18.3848C19.1589 18.3645 18.9754 18.2882 18.8245 18.1651C16.8845 16.3251 12.7045 14.1651 3.82449 14.1651C2.69314 13.9737 1.67449 13.3656 0.969275 12.4604C0.264059 11.5553 -0.0765783 10.4189 0.0144871 9.27509C-0.0412198 8.2117 0.318977 7.16836 1.01886 6.36582C1.71874 5.56329 2.7034 5.06453 3.76449 4.97509C3.76449 4.97509 12.5145 6.08509 18.7745 0.285089Z",
    transform: "translate(1 3)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V8.23",
    transform: "translate(5.69434 8.52539)",
    stroke: "#1E334E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V15.74",
    transform: "translate(18.6641 4.52539)",
    stroke: "#1E334E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.84 3.87C1.92125 4.02715 2.04274 4.15994 2.19207 4.2548C2.34139 4.34967 2.51322 4.40322 2.69 4.41H3.86L1.93 0.0600004",
    transform: "translate(7.10449 17.0254)",
    stroke: "#1E334E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllInclusive);
export default __webpack_public_path__ + "static/media/AllInclusive.92698dcde4f92eba36dce2f7c16367ac.svg";
export { ForwardRef as ReactComponent };